import Swiper from 'swiper/dist/js/swiper.jquery';

const defaults = {
  threshold: 5,
  simulateTouch: false,
};

export default function(el, options) {
  return new Swiper(el, Object.assign({}, defaults, options));
}